import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class UtcDateInterceptor implements HttpInterceptor {

    // Regex to match ISO date-time strings that do not end with Z or timezone offset.
    // Example: 2026-03-28T00:29:56 or 2026-03-28T00:29:56.123
    private readonly isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?$/;

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            map((event: HttpEvent<unknown>) => {
                if (event instanceof HttpResponse && event.body) {
                    this.convertDatesToUtc(event.body);
                }
                return event;
            })
        );
    }

    private convertDatesToUtc(body: any): void {
        if (body === null || body === undefined) {
            return;
        }

        if (typeof body !== 'object') {
            return;
        }

        for (const key of Object.keys(body)) {
            const value = body[key];
            if (typeof value === 'string' && this.isoDateRegex.test(value)) {
                // Append 'Z' to treat it as UTC time
                body[key] = value + 'Z';
            } else if (typeof value === 'object') {
                this.convertDatesToUtc(value);
            }
        }
    }
}
